import React, { useState } from "react";
import { Alert, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { setUser_ContactsList, setUser_ContactsMessage } from "redux/actions";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import { getUser_Contacts } from "services/user_contactsService";
import Layout from "template";
import { Constant } from "template/Constant";
import { User_ContactsForm } from "./form";
import { User_ContactsTable } from "./table";

export const User_Contacts: React.FC = () => {
  const dispatch = useAppDispatch();
  const rData = useSelector((state: RootState) => state.user_contacts);
  const [row, setRow] = useState(undefined);
  const [action, setAction] = useState("");
  const getData = (page, pageSize, searchKey) => {
    getUser_Contacts(page, pageSize, searchKey).then((response) => {
      if (response && response.records) {
        dispatch(
          setUser_ContactsList({
            pageNo: page,
            pageSize: pageSize,
            list: response.records,
            totalCount: response.totalCount,
            searchKey: searchKey,
          })
        );
      } else {
        dispatch(
          setUser_ContactsMessage({
            text: "No Record Found",
            type: Constant.alertVariantDanger,
          })
        );
      }
    });
  };

  const handleRowEdit = (rowData) => {
    setRow(rowData);
    dispatch(
      setUser_ContactsMessage({ text: "", type: Constant.alertVariantSuccess })
    );
    setAction("edit");
  };

  return (
    <Layout>
      <div className="container-fluid">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <h1 className="h3 mb-0 text-gray-800">Контакты</h1>
        </div>
        <div className="d-flex flex-column min-vh-100">
          {rData.message.text ? (
            <Alert
              variant={rData.message.type}
              className="alert-dismissible fade">
              {rData.message.text}
              <Button
                type="button"
                className="close"
                data-dismiss="alert"
                aria-label="Close"
                onClick={() =>
                  dispatch(
                    setUser_ContactsMessage({
                      text: "",
                      type: Constant.alertVariantSuccess,
                    })
                  )
                }>
                <span aria-hidden="true">&times;</span>
              </Button>
            </Alert>
          ) : null}
          {action ? (
            <User_ContactsForm
              hideShowForm={setAction}
              action={action}
              row={row}
              getData={getData}
            />
          ) : (
            <User_ContactsTable
              handleRowEdit={handleRowEdit}
              hideShowForm={setAction}
              getData={getData}
              action={action}
            />
          )}
        </div>
      </div>
    </Layout>
  );
};
